import {
  React,
  Select,
  Switch,
  Button,
  Grid,
  Box,
  Modal,
  // ScreenWisePostScheduling,
  GroupWisePostScheduling,
  useCreateGroupPostMutation,
  useGetGroupPostMutation,
  useDeleteGroupPostMutation,
  useChangeGroupPostorderMutation,
  useChangeGroupPoststatusMutation,
  useChangeGroupPostimagedurationMutation,
  useUpdategroupfooterMutation,
  useGetscreensforgroupMutation,
  useGetAllScreensMutation,
  useAddMediatoAsOfflineGroupMutation,
   useLocation,
   useState,
   useEffect,
   toast,
   swal,
   useNavigate,
   LoadingSpinner,
} from "../../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";
import add_media_image from "../../../Assets/svgs/add_media_image.svg";
import {captureeventbaseanalytics,
} from "../../../Libraries/Media/index";
import Marquee from "react-fast-marquee";
import {
  useGetSelectiveNewsMutation,
  useGetRSSNewsMutation,
  useEnquiremediaMutation,
} from "../../../Redux/service/AllEmpData";
import GetCookie from "../../../Pages/Authentication/Loginpage/Cookies/GetCookie/getcookies";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "../../../Libraries/Post/Customization/index";
import ImageLazyLoading from "../../../components/ImageLazyLoad/ImageLazyLoading";
import { IconButton } from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Dialog,
  ChooseMedia,
} from "../../../Libraries/Post/AddNewPost/Child/AddPostMiddleForm/index";
import { ContactSupportOutlined } from "@mui/icons-material";
import ViewgroupScreens from "../../../components/Groups/ViewgroupScreens";

export default function AddNewGroupMediaMapping() {
  const location = useLocation();
    const [openAddpostDialog, setOpenAddPostDialog] = React.useState(false);
    const [showRefershScreen, setShowRefreshScreen] = React.useState(false);
    const [showScreens, setShowScreens] = useState(false);
    const [currentScreen, setCurrentScreen] = useState(location?.state);
    const [mediaforcurrentgroup, setMediaForCurrentGroup] = useState(null);
    const [groupscreendata, setgroupscreeensdata] = useState([]);
    const [footerText, setFooterText] = useState("");
    const [footerRssLink, setFooterRssLink] = useState("");
    const [defaultScreen, setDefaultScreen] = useState(location?.state);
    const [allgroupdata, setgroupdata] = useState(location.state);
    // const [currentGroup, setCurrentGroup] = useState(location?.state);
    const [openLiveView, setOpenLiveView] = useState(false);
    const [enquireMedia] = useEnquiremediaMutation();
    const [options, setoptions] = useState([]);
    const [getRSSNews] = useGetRSSNewsMutation();
    const [getSelectiveNews] = useGetSelectiveNewsMutation();
    const navigate = useNavigate();
     const [nodata, setnodata] = useState(false);
    const [data, setdata] = useState({
        playingpost: false,
        selectedpost: null,
        screenwisePostStatuscomponent: false,
      });
    const [creategrouppost] = useCreateGroupPostMutation();
    const [getgrouppost , { isLoading }] = useGetGroupPostMutation();
    const [deletegrouppost] = useDeleteGroupPostMutation();
    const [changegrouporderpost] = useChangeGroupPostorderMutation();
    const [changegroupstatuspost] = useChangeGroupPoststatusMutation();
    const [changeimageduration] = useChangeGroupPostimagedurationMutation();
    const [updatefootergroup] = useUpdategroupfooterMutation();
    const [getAllScreensfromdb] = useGetAllScreensMutation();
    const [getgroupscreens] = useGetscreensforgroupMutation();
    const [groupofflinemedia] = useAddMediatoAsOfflineGroupMutation();
    const [marqueeText, setMarqueeText] = useState([]);
    // const currentScreen = location.state;
    const durationOptions = [
    { value: "30000", label: "30 seconds" },
    { value: "60000", label: "1 minute" },
    { value: "120000", label: "2 minute" },
  ];

    
  const [postData, setPostdata] = useState({
      selectedLayout: location.state?.ser_layout_id
        ? location.state?.ser_layout_id
        : "1",
      selectedScreens: location.state?.screens
        ? location.state.screens
        : location.state?.track
        ? location.state
        : [],
      PostStatus: location.state?.txt_post_status
        ? location.state?.txt_post_status
        : "false",
      PostTitle: location.state?.txt_post_title
        ? location.state?.txt_post_title
        : "",
      finalfile: location.state?.finalfile ? location.state.finalfile : null,
      selectedDuration: location.state?.txt_post_duration
        ? location.state?.txt_post_duration
        : [],
      radiobuttonvalue: "Day wise",
    });

    ////////////////////////
    // Function for Offline 
    ////////////////////////
    const handleMediaAsOffline = async (media) => {
        try {
          const payload = new FormData();
          payload.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          payload.append("security_token", await GetCookie("es_token"));
          payload.append("ser_media_id", media.finalfile.ser_media_id);
          payload.append("ser_assoc_id", media.ser_assoc_id);
          payload.append("ser_collection_id", media.ser_collection_id);
          payload.append("txt_media_offline_status", media.is_offline_available=='true'?'false':'true');
    
          const res = await groupofflinemedia(payload).unwrap();
          if (res.connection === "true" && res.status === "true") {
            toast.success(res.message);
            getAllPostGroup();
          } else {
            toast.error(res.message);
          }
        } catch (error) {
          console.log(error);
          toast.error(error.status);
        }
      };
    /////////////////////////////////////////////
    // Function for Delete Assign Post for Group
    ////////////////////////////////////////////
    const handleDeleteMediagroup = async (e, index) => {
      let mediaToUpdate = "";
      // SSBR
      // const mediaToUpdate = mediaforcurrentgroup[index];
      //Use this:
      if (Number.isInteger(index) && index >= 0 && index < mediaforcurrentgroup.length
      ) {
        mediaToUpdate = mediaforcurrentgroup[index];
      }


  setShowRefreshScreen(true);

  swal({
    title: "Remove Media!",
    text: "Are you sure you want to remove the media from this screen?",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  }).then(async (willUnLink) => {
    if (willUnLink) {
      try {
          // Proceed to delete from group
          const deletePayload = new FormData();
          deletePayload.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          deletePayload.append(
            "security_token",
            await GetCookie("es_token")
          );
          deletePayload.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);

          const deleteRes = await deletegrouppost(deletePayload).unwrap();
          if (
            deleteRes.status === "true" &&
            deleteRes.connection === "true" &&
            deleteRes.message === "Media deleted successfully"
          ) {
            toast.success(deleteRes.message);
            getAllPostGroup();
          } else {
            toast.error(deleteRes.message);
          }
      } catch (error) {
        console.log("Error:", error);
        toast.error(error.message || "Unexpected error occurred.");
        captureeventbaseanalytics("Media", "Delete Flow Error", error.message);
      }
    }
  });
};  
    ////////////////////////////////////
    //Function For Assign Post to Group
    ///////////////////////////////////
    async function hideDialogAndCreatePost() {
      
      const createPostFormData = new FormData();
      createPostFormData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      createPostFormData.append("security_token", await GetCookie("es_token"));
      createPostFormData.append("post_type", postData.finalfile.type);
      createPostFormData.append("txt_post_status", postData.PostStatus);
      createPostFormData.append("ser_media_id", postData.finalfile.ser_media_id);
      createPostFormData.append("ser_collection_id", currentScreen[0].value);
      createPostFormData.append(
        "image_post_duration",
        postData.finalfile.type === "Image" ? "30000" : "N/A"
      );
      const res = await creategrouppost(createPostFormData);
       if (
          res.data.status === "true" &&
          res.data.connection === "true"
        ) {
          hideDialog();
          toast.success(res.data.message);
          getAllPostGroup();
          setnodata(false);
  
        } else if (
          res.data.status === "false" &&
          res.data.connection === "true" &&
          res.data.message === "No Posts available"
        ) {
          setnodata(true);
          // setMediaForCurrentGroup(null);
        } else {
          toast.info(res.data.message);
        }

  }
    const addnewpost = () => {
      setOpenAddPostDialog(true);
      setShowRefreshScreen(true);
    };
   const mediaselectionfooter = (
      <React.Fragment>
        <Button
          variant="contained"
          className="mt-3 capitalized fs-14 fw-bold"
          onClick={hideDialogAndCreatePost}
        >
          Submit
        </Button>
      </React.Fragment>
    );
   const hideDialog = () => {
    setOpenAddPostDialog(false);
  };
  const handleChangefinalfile = (value) => {
        setPostdata({
          ...postData,
          finalfile: value,
        });
      };
  const getAllPostGroup = async () => {
      try {
        const formData = new FormData();
        formData.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        formData.append("security_token", await GetCookie("es_token"));
        formData.append("ser_collection_id", currentScreen[0].value);
  
        const returned = await getgrouppost(formData);
        if (
          returned.data.status === "true" &&
          returned.data.connection === "true" &&
          returned.data.message === "Posts available"
        ) {
          setMediaForCurrentGroup(returned.data.data);
          setoptions(returned.data.orders);
  
        } else if (
          returned.data.status === "false" &&
          returned.data.connection === "true" &&
          returned.data.message === "No Posts available"
        ) {
          setMediaForCurrentGroup(null);
          setnodata(true);
        } else {
          toast.info(returned.message);
        }
      } catch (error) {
        toast.error(error.error);
      }
    };
  useEffect(() => {
        getAllPostGroup();
        getFooterValue();
      }, []);

  const handleChangeGroupPostStatus = async (e, index) =>{
     try {
      let mediaToUpdate ="";
      //SSBR
      //const mediaToUpdate = mediaforcurrentgroup[index];
      //Use This:
      if (Number.isInteger(index) && index >= 0 && index < mediaforcurrentgroup.length) {
        mediaToUpdate = mediaforcurrentgroup[index];

      }
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("post_status", !mediaToUpdate.post_status);
      payload.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);

      const res = await changegroupstatuspost(payload).unwrap();
      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Post status updated successfully"
      ) {
        toast.success(res.message);
        getAllPostGroup();
      } else if (res.connection === "true" && res.status === "false") {
        toast.info(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    }
  }
const handleChangeDuration = async (e, index) => {
    try {
      // setShowRefreshScreen(true);
      let mediaToUpdate = "";
      //SSBR
      // const mediaToUpdate = mediaforcurrentgroup[index];
       if (Number.isInteger(index) && index >= 0 && index < mediaforcurrentgroup.length
      ) {
          mediaToUpdate = mediaforcurrentgroup[index];
      }
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("image_post_duration", e.value);
      payload.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);

      const res = await changeimageduration(payload).unwrap();
      // console.log("latest = ", res);

      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Timer updated successfully"
      ) {
        toast.success(res.message);
        getAllPostGroup();
      } else if (res.connection === "true" && res.status === "false") {
        toast.info(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {}
  };

  const handlegroupOrder = async (e, index) => {
    const formObj = new FormData();
          formObj.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          // formObj.append("security_token", await GetCookie("es_token"));
          formObj.append("security_token", await GetCookie("es_token"));
          // INstead of this
          // formObj.append("ser_assoc_id", mediaforcurrentgroup[index].ser_assoc_id);
          //SSBR
          // Use this
          let mediaassocid = "";
          if (Number.isInteger(index) && index >= 0 && index < mediaforcurrentgroup.length) {
              mediaassocid = mediaforcurrentgroup[index].ser_assoc_id;
          }
          formObj.append("ser_assoc_id", mediaassocid);
          formObj.append("ser_collection_id", defaultScreen[0].value);
          formObj.append("txt_order_no", e[0].value);
    
          try {
            const returned = await changegrouporderpost(formObj).unwrap();
            if (
              returned.connection === "true" &&
              returned.message === "Order changed successfully" &&
              returned.status === "true"
            ) {
              toast.success(returned.message);
              getAllPostGroup();
            } else {
              toast.error(returned.message);
            }
          } catch (error) {
            console.log(error);
            toast.error(error.status);
            // you can handle errors here if you want to
          }
      };

  const handleSchduleModal = (media) => {
    // console.log("Testing"+media);

    // setShowRefreshScreen(true);
    setdata({
      ...data,
      selectedpost: media,
      screenwisePostStatuscomponent: true,
    });
  };

  const handleLiveView = () => {
    if (
      defaultScreen[0]?.footer_option === "News" || defaultScreen[0]?.footer_option === "Urdu News" ||
      defaultScreen[0]?.footer_option === "English News" ||
      defaultScreen[0]?.footer_option === "Cricinfo"
    ) {
      getNewsTextForPreview(defaultScreen[0]?.footer_option, true);
      // setOpenLiveView(true)
    } else if (defaultScreen[0]?.footer_option === "RSS") {
      // call api for RSS

      getRssNewsForPreview(defaultScreen[0]?.footer_value, true);
    } else if (defaultScreen[0]?.footer_option === "Text") {
      const textObjForMarquee = [
        // { txt_news_title: defaultScreen[0]?.footer_value },
        {txt_news_title: footerText },
      ];
      setMarqueeText(textObjForMarquee);
      setOpenLiveView(true);
    }

    // setOpenLiveView(true)
  };
  const getRssNewsForPreview = async (footer_value, openLivePreview) => {
      var returnValue = "";
      try {
        // console.log("opt 1 =", footer_value);
        // console.log("opt 2 =", footerRssLink);
        const formData = new FormData();
  
        formData.append("txt_rss_link", footerRssLink);
  
        const res = await getRSSNews(formData).unwrap();
        // console.log("RSS res = ", res);
  
        if (res.status === "true" && res.message === "Rss data available") {
          // console.log("res = ", res.data);
          if(!openLivePreview){returnValue = res.data;}
          else{
          setMarqueeText(res.data);
          setOpenLiveView(true);
          toast.success(res.message);
          }
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.status);
      }
      return returnValue;
    };
  const getNewsTextForPreview = async (footer_key, openLivePreview) => {
    var returnValue = "";
    try {

      const formData = new FormData();
      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("footer_key", footer_key);

      const res = await getSelectiveNews(formData).unwrap();
      // console.log("res = ", res.data);

      if (
        res.status === "true" &&
        res.message === "News available" &&
        res.connection === "true"
      ) {
        // console.log("res = ", res.data);
        if(!openLivePreview){returnValue = res.data;}
        else{
        setMarqueeText(res.data);
        setOpenLiveView(true);
        toast.success(res.message);
        }
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }

    return returnValue;
  };

  const handleSchduleModalClose = () => {
    setdata({
      ...data,
      selectedpost: null,
      screenwisePostStatuscomponent: false,
    });
    getAllPostGroup();
  };
  const handleUpdateScreenFooterOption =async (screenParams, rssLink, text)=>{
    try {
        const formData = new FormData();
        formData.append("footer_option", screenParams);

        if (screenParams !== null && screenParams === "RSS") {
          formData.append("footer_value", rssLink);
          setFooterText("");
        } else if (screenParams !== null && screenParams === "Text") {
          formData.append("footer_value", text);
          setFooterRssLink("");
        } else {
          formData.append("footer_value", "N/A");
        }

        formData.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        formData.append("security_token", await GetCookie("es_token"));
        formData.append("ser_collection_id", currentScreen[0].value);

        const returned = await updatefootergroup(formData).unwrap();

        if (
          returned.status === "true" &&
          returned.connection === "true" &&
          returned.message === "Footer updated successfully"
        ) {
          var temp = [...currentScreen]; 

         const deepCopy = JSON.parse(JSON.stringify(temp[0])); // Deep copy

          deepCopy.footer_option = screenParams;
          if (screenParams !== null && screenParams === "RSS") {
            deepCopy.footer_value = rssLink
          }
          else if(screenParams !== null && screenParams === "Text"){
            deepCopy.footer_value = text
          }
          temp[0] = deepCopy;
          setCurrentScreen([...temp]);
          toast.success(returned.message);
        } else {
          toast.info(returned.message);
        }
      } catch (error) {
        toast.error(error.error);
        console.error(error);
      }
  }
  const handleviewscreens = async () => {
      const customerid = localStorage.getItem("txt_customer_id");
      const verifyscreenotp = new FormData();
      verifyscreenotp.append("txt_customer_id",customerid);
      verifyscreenotp.append("security_token", await GetCookie("es_token")); 
      try {
        const response = await getAllScreensfromdb(verifyscreenotp);
        if(response.data.status === 'true'){
          setgroupscreeensdata(response.data.data);
          setShowScreens(true);
        }
      } catch (error) {
        // toast.error(error.status);
        console.log(error);
      }
  }
  const getFooterValue = () => {
    if (location?.state[0].footer_option === "News") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "News" } : item
        )
      );
    } else if (location?.state[0].footer_option === "Cricinfo") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "Cricinfo" } : item
        )
      );
    }else if (location?.state[0].footer_option === "English News") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "English News" } : item
        )
      );
    }
    else if (location?.state[0].footer_option === "Urdu News") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "Urdu News" } : item
        )
      );
    }


    else if (location?.state[0].footer_option === "RSS") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "RSS" } : item
        )
      );

      setFooterRssLink(location?.state[0].footer_value);
    } else if (location?.state[0].footer_option === "Text") {
      // console.log("inside text =", location?.state[0].footer_option);
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "Text" } : item
        )
      );

      setFooterText(location?.state[0].footer_value);
    } else {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "none" } : item
        )
      );
    }
  };
  function sizeFormat (bytes) {
    const kb = 1024;
    const mb = kb * 1024;
    const gb = mb * 1024;
    const tb = gb * 1024;
  
    if (bytes >= 0 && bytes < kb) {
      return `${bytes}B`;
    } else if (bytes >= kb && bytes < mb) {
      return `${Math.ceil(bytes / kb)}KB`;
    } else if (bytes >= mb && bytes < gb) {
      return `${Math.ceil(bytes / mb)}MB`;
    } else if (bytes >= gb && bytes < tb) {
      return `${Math.ceil(bytes / gb)}GB`;
    } else if (bytes >= tb) {
      return `${Math.ceil(bytes / tb)}TB`;
    } else {
      return `${bytes}B`;
    }
  };
   const handlePreviewClick = async (index) => {
    // console.log("test = ", mediaforcurrentgroup[index])

    var footer_value = "";
    if (
      defaultScreen[0]?.footer_option === "News" ||
      defaultScreen[0]?.footer_option === "Cricinfo"
    ) {
      footer_value = await getNewsTextForPreview(
        defaultScreen[0]?.footer_option,
        false
      );
      // setOpenLiveView(true)
    } else if (defaultScreen[0]?.footer_option === "RSS") {
      // call api for RSS

      footer_value = await getRssNewsForPreview(
        defaultScreen[0]?.footer_value,
        false
      );
    } else if (defaultScreen[0]?.footer_option === "Text") {
      footer_value = defaultScreen[0]?.footer_value;
    }
    // console.log("test wahaj =", mediaForCurrentScreen[index]);

    var temp = [...mediaforcurrentgroup]; // Shallow copy

    const deepCopy = JSON.parse(JSON.stringify(temp[index])); // Deep copy//Atack Report

    deepCopy.footer_value = footer_value;
    // console.log("test wahaj 2 = ", deepCopy);

    var layput_id;

    if (footer_value === "") {
      layput_id = "1";
    } else {
      layput_id = "2";
    }
    //SSBR
    let mediagroupindex = null;
    if (Number.isInteger(index) && index >= 0 && index < mediaforcurrentgroup.length) {
      mediagroupindex = mediaforcurrentgroup[index];
    }
    const navigationState = {
      // media: mediaforcurrentgroup[index],old one
       media: mediagroupindex,
      ser_layout_id: layput_id,
      from: "newMediaScreen",
      currentScreen: currentScreen,
      footer: footer_value,
    };

    navigate("/layoutpreview", { state: navigationState });
  };
 
  
  return (
     <>
     {isLoading ? <LoadingSpinner /> : null}
      <Box sx={{ flexGrow: 1, mr: 3, mt: 1 }}>
        <div className="row  mt-4 mb-4 no-gutters">
          <div
            className="col d-flex "
            style={{ backgroundColor: "", alignItems: "center" }}
          >
        <IconButton>
        <ArrowBackIcon
          fontSize="medium"
          style={{color:'black'}}
          onClick={() => {
            navigate("/groups");

          }}
        />
        </IconButton>
            {currentScreen &&(
            <h4 className="text-capitalize" style={{ margin: 0 }}>
              <b>{currentScreen[0].label}</b>
            </h4>
            )}
          </div>
          <div
            className="col col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end"
            style={{ backgroundColor: "" }}
          >
            <Button
            variant="outlined"
            sx={{ maxHeight: "40px", fontWeight: 'bold', textTransform: 'none' }}
            className="mr-1 capitalized fs-14 fw-bold"
            onClick={handleviewscreens}
          >
           View Screens
          </Button>
            <Button
              variant="contained"
              sx={{ maxHeight: "40px", fontWeight: 'bold',textTransform: 'none' }}
              className="mr-1 capitalized fs-14 fw-bold"
              onClick={addnewpost}
            >
              Add Media
            </Button>
          </div>
        </div>
         {mediaforcurrentgroup !== null ? (
          <>
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={0}
                className="flex justify-content-between align-items-center"
              >
                <Grid
                  item
                  xs={8}
                  md={12}
                  lg={12}
                  className="surface-0 shadow-2 p-3 mr-2 ml-2"
                  style={{ borderRadius: "8px" }}
                >
                  <div className="row justify-content-between no-gutters ml-1 mr-1">
                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <h5 style={{ color: "grey" }}>
                        <b>Media</b>
                      </h5>
                    </div>
                  </div>

                  <div className="shadow-4 rounded-1 overflow-hidden">
                    <table className="table align-middle bg-white">
                      <thead className="bg-light">
                        <tr>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Preview
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            File Name
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Sequence
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Display
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Offline
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Duration
                          </th>

                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Schedule
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Delete
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                         {mediaforcurrentgroup &&
                          mediaforcurrentgroup.map((currentRow, index) => (
                            <tr key={currentRow.ser_assoc_id}>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                              <div onClick={() => {handlePreviewClick(index)}}>
                                <ImageLazyLoading
                                  src={
                                    currentRow.finalfile.txt_media_file_type ===
                                    "Video"
                                      ? currentRow.base64_media_thumbnail
                                      : currentRow.finalfile
                                          .txt_media_streaming_link
                                  }
                                  alt={"img"}
                                  width={"135px"}
                                  height={"75px"}
                                  style={{
                                    borderRadius: "8px",
                                    border: "3px solid #F0F0F0",
                                  }}

                                />
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                {/* <h6>{currentRow.txt_media_full_name}</h6> */}
                                <h6>{sizeFormat(currentRow.media_size)}</h6>
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                {/* <Select
                                  isMulti="true"/> */}
                              <Select
                              isMulti="true"
                              options={options}
                              value={currentRow.order_no}
                              onChange={(e) => {
                                handlegroupOrder(e, index);
                              }}
                              isClearable={true}
                              placeholder={currentRow.order_no}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                            />
                              </td>

                              <td
                                style={{
                                  width: "10%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                {/* <Switch
                                  inputProps={{ "aria-label": "controlled" }}
                                /> */}
                              <Switch
                                checked={currentRow.post_status}
                                inputProps={{ "aria-label": "controlled" }}
                                onChange={(e) => {
                                  handleChangeGroupPostStatus(e, index);
                                }}
                              />
                              </td>
                              <td
                                style={{
                                  width: "10%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Switch
                                  checked={currentRow.is_offline_available=='true'?true:false}
                                  inputProps={{ "aria-label": "controlled" }}
                                  onChange={(e) => {
                                    handleMediaAsOffline(currentRow);
                                  }}
                                />
                              </td>

                              <td
                                style={{
                                  width: "30%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <div>
                                  <Select
                                    isDisabled={
                                      currentRow.finalfile
                                        .txt_media_file_type === "Image"
                                        ? false
                                        : true
                                    }
                                    options={durationOptions}
                                    value={durationOptions.find(
                                      (option) =>
                                        option.value ===
                                        currentRow.image_post_duration
                                    )}
                                    // value={currentRow.image_post_duration}
                                    onChange={(e) => {
                                      handleChangeDuration(e, index);
                                    }}
                                    isClearable={true}
                                    placeholder={currentRow.image_post_duration}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                  />
                                </div>
                              </td>

                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                              <IconButton>
                                <AccessTimeFilledIcon
                                  onClick={() =>
                                    handleSchduleModal(currentRow)
                                  }
                                  color={
                                    currentRow.is_scheduled === true
                                      ? "primary"
                                      : "action"
                                  }
                                />
                              </IconButton>
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                              <IconButton>
                                <DeleteIcon
                                  onClick={(e) => handleDeleteMediagroup(e, index)}
                                  // sx={{ color: red[900] }}
                                />
                              </IconButton>
                              </td>
                            </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={0}
                className="flex justify-content-between align-items-center mt-3 mb-6"
              >
                <Grid
                  item
                  xs={8}
                  md={12}
                  lg={12}
                  className="surface-0 shadow-2 p-3 mr-2 ml-2 mb-4"
                  style={{ borderRadius: "8px" }}
                >
                  <div className="row justify-content-between no-gutters ml-1 mr-1">
                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <h5 style={{ color: "grey" }}>
                        <b>Add Footer</b>
                      </h5>
                    </div>
                  </div>

                  <div className="row justify-content-between no-gutters ml-1 mr-1">
                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={
                            defaultScreen[0]?.footer_option == null
                              ? "none"
                              : defaultScreen[0]?.footer_option
                          } //selectedFooterSource
                          onChange={(e) => {
                            // console.log("e = 1", e.target.value);
                            // console.log("e =", defaultScreen[0]?.footer_option);

                            setDefaultScreen((prevDefaultScreen) =>
                              prevDefaultScreen.map((item, itemIndex) =>
                                itemIndex === 0
                                  ? { ...item, footer_option: e.target.value }
                                  : item
                              )
                            );

                            // console.log("e 2=", defaultScreen[0].footer_option);
                          }}
                        >
                          {/* <FormControlLabel
                            value="News"
                            control={<Radio />}
                            label="News"
                          /> */}
                           <FormControlLabel
                            value="Urdu News"
                            control={<Radio />}
                            label="Urdu News"
                          />
                           <FormControlLabel
                            value="English News"
                            control={<Radio />}
                            label="English News"
                          />
                          <FormControlLabel
                            hidden="true"
                            value="Cricinfo"
                            control={<Radio />}
                            label="Cricinfo"
                          />
                          <FormControlLabel
                            value="Text"
                            control={<Radio />}
                            label="Text"
                          />
                          {/* <FormControlLabel
                            value="RSS"
                            control={<Radio />}
                            label="RSS"
                          /> */}
                          <FormControlLabel
                            value="none"
                            control={<Radio />}
                            label="None"
                          />
                          {defaultScreen[0]?.footer_option === "none" ? null : (
                            <Button
                              onClick={() => {
                                handleLiveView();
                              }}
                              className="capitalized fs-14 fw-bold"
                            >
                              Live View
                            </Button>
                          )}
                        </RadioGroup>
                      </FormControl>
                    </div>

                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <Button
                        style={{ float: "right", maxHeight: "40px", fontWeight: 'bold',textTransform: 'none' }}
                        color="primary"
                        variant="contained"
                         onClick={() => {
                          handleUpdateScreenFooterOption(
                            defaultScreen[0].footer_option,
                            footerRssLink,
                            footerText
                          );
                        }}
                        className="capitalized fs-14 fw-bold"
                      >
                        Update Footer
                      </Button>
                    </div>
                  </div>
                   <div col col-sm-6 col-md-6 col-lg-6>
                      {data.PostWidget === "GenericDescription" ? (
                        <div className="form-group col-md-6 mt-3">
                          <label htmlFor="inputEmail4">
                            Footer Generic Description
                          </label>
                          <textarea
                            value={data.GenericDescription}
                            // onChange={(e) => handleGenericDescription(e)}
                            style={{ overflow: "hidden" }}
                          />
                        </div>
                      ) : defaultScreen[0].footer_option === "RSS" ? (
                        <div className="form-group col-md-6 mt-3">
                          <label htmlFor="inputEmail4">Footer RSS Link</label>
                          <textarea
                            value={footerRssLink}
                            name="footer_widget_rss_link"
                            // onChange={
                            //   (e) => setFooterRssLink(e.target.value)
                            //   // (e) => hansleFooterRSSLink(e)
                            // }
  
                            onChange={
                              (e) => {
                                setFooterRssLink(e.target.value);
                              }
  
                              // (e) => handleFooterRSSLink(e)
                            }
                            style={{ overflow: "hidden" }}
                          />
                        </div>
                      ) : defaultScreen[0].footer_option === "Text" ? (
                        <div className="form-group col-md-6 mt-3">
                          <label htmlFor="inputEmail4">Footer Text</label>
                          <textarea
                            value={footerText}
                            name="footer_widget_text"
                            onChange={
                              (e) => setFooterText(e.target.value)
                              // handleFooterText(e)
                            }
                            style={{ overflow: "hidden" }}
                          />
                        </div>
                      ) : defaultScreen[0].footer_option === "Newss" ? (
                        <FormControl component="fieldset">
                          <FormGroup aria-label="position" row>
                            <Select
                              // options={newsSources}//AllCustomization.footer.footer_widget_news_source
                              // value={AllCustomization.footer.footer_widget_news_source}
                              onChange={(e) => {
                                // handleNewsChangedrop(e)
                              }}
                              onClose={() => {
                                toast.error("close");
                              }}
                              name="footer_body_news_option_name"
                              isClearable={true}
                              placeholder="News options"
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              isMulti="true"
                              styles={{
                                menuPortal: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </FormGroup>
                        </FormControl>
                      ) : null}
                    </div>
                </Grid>
              </Grid>
                 
            </Box>
          </>
          ) : (
            nodata && (
            <div className="col d-flex justify-content-center">
              <img
                style={{ maxWidth: "600px", minWidth: "200px", width: "100%" }}
                src={add_media_image}
                alt="No media"
              />
            </div>
           )
        )}
      </Box>
      <Modal
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          modal: {
            width: "90%",
            height: "65vh",
            padding: "unset",
            overflow: "hidden",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
          },
        }}
        center
      >
      </Modal>

      <Modal
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          modal: {
            width: "90%",
            height: "15%",
            padding: "unset",
            overflow: "hidden",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
          },
        }}
        center
      >
      </Modal>
       <Dialog
                        visible={openAddpostDialog}
                        style={{ width: "1200px", height: "600px" }}
                        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
                        header={"Select Media"}
                        modal
                        maximizable={true}
                        footer={mediaselectionfooter}
                        onHide={hideDialog}
                      >
                        <ChooseMedia
                          setfinalfile={handleChangefinalfile}
                          finalfile={postData.finalfile}
                        />
                      </Dialog>
      {data.screenwisePostStatuscomponent === true ? (
              <GroupWisePostScheduling
                show={data?.screenwisePostStatuscomponent}
                close={handleSchduleModalClose}
                screen={defaultScreen[0].value}
                schinfo={data?.selectedpost}
                getAllPosts={getAllPostGroup}
                defaultScreen={defaultScreen}
              />
            ) : null}
            {/* {showScreens && <ViewgroupScreens data={groupscreendata} groupdata ={allgroupdata} getgroupscreens = {getgroupscreens} />} */}
             <Modal
        open={openLiveView}
        onClose={() => {
          setOpenLiveView(false);
        }}
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          modal: {
            width: "90%",
            height: "15%",
            padding: "unset",
            overflow: "hidden",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
          },
        }}
        center
      >
        <Marquee className="mt-6" speed={20} direction={defaultScreen[0]?.footer_option === "Urdu News" ? "right" : "left"}>
          {/* news['txt_news_title'] */}

          {/* {marqueeText[index].txt_news_title} */}
          {marqueeText.map((data) => {
            return <p>{data?.txt_news_title + "                      ."}</p>;
          })}
        </Marquee>
      </Modal>
             <ViewgroupScreens
                  open={showScreens}
                  onClose={() => setShowScreens(false)}
                  data={groupscreendata}
                  groupdata={allgroupdata}
                  getgroupscreens={getgroupscreens}
                  GetCookie= {GetCookie}
                  displaymapbutton = {false}
                />
    </>
  )
}
